"use strict";
// Copyright 2019 Centrality Investments Limited
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("@cennznet/util");
const derives = __importStar(require("./derives"));
const EnhancedAssetId_1 = __importDefault(require("./registry/EnhancedAssetId"));
class GenericAsset {
    static async create(api) {
        if (api.genericAsset) {
            return api.genericAsset;
        }
        api._options.derives = { ...api._options.derives, genericAsset: derives };
        await api.loadMeta();
        return new GenericAsset(api);
    }
    constructor(api) {
        util_1.assert(api._options.derives.genericAsset || (api._derive || {}).genericAsset, "init generic asset's derives first");
        this._api = api;
        api.registerTypes({
            AssetId: EnhancedAssetId_1.default,
        });
    }
    get api() {
        return this._api;
    }
    /**
     * Create an asset
     * @param options Initialization options of an asset
     */
    create(options) {
        return this.api.tx.genericAsset.create(options);
    }
    /**
     * Transfer asset to the destination account
     * @param assetId The id or symbol (for reserved asset) of the transferred asset
     * @param dest The address of the destination account
     * @param amount The amount to be transferred
     */
    transfer(assetId, dest, amount) {
        return this.api.tx.genericAsset.transfer(new EnhancedAssetId_1.default(assetId), dest, amount);
    }
    /**
     * Query the next available asset ID
     */
    get getNextAssetId() {
        return this.api.query.genericAsset.nextAssetId;
    }
    /**
     * Query the total issuance of an asset
     * @return a QueryableStorageFunction that needs a argument assetId
     * @param assetId id or symbol (for reserved asset) of the asset
     */
    get getTotalIssuance() {
        return this.api.query.genericAsset.totalIssuance;
    }
    // tslint:disable:member-ordering
    /**
     * Query free balance of an asset for an account
     * @param assetId The id or symbol (for reserved asset) of the asset
     * @param address The address of the account
     */
    get getFreeBalance() {
        const _fn = this.api.derive.genericAsset.freeBalance;
        _fn.at = this.api.derive.genericAsset.freeBalanceAt;
        return _fn;
    }
    /**
     * Query reserved balance of an asset for an account
     * @param assetId The id or symbol (for reserved asset) of the asset
     * @param address The address of the account
     */
    get getReservedBalance() {
        const _fn = this.api.derive.genericAsset.reservedBalance;
        _fn.at = this.api.derive.genericAsset.reservedBalanceAt;
        return _fn;
    }
    /**
     * Query total balance of an asset for an account
     * @param assetId The id or symbol (for reserved asset) of the asset
     * @param address The address of the account
     */
    get getTotalBalance() {
        const _fn = this.api.derive.genericAsset.totalBalance;
        _fn.at = this.api.derive.genericAsset.totalBalanceAt;
        return _fn;
    }
}
exports.GenericAsset = GenericAsset;
//# sourceMappingURL=GenericAsset.js.map